module.exports = __webpack_public_path__ + "img/inspiration.02aefad2.png";